import React, { useState } from 'react'
import useForm from "../../services/useForm";
import validate from '../../services/validations/loginFormValidationRules';
// import FacebookLogin from 'react-facebook-login';
// import GoogleLogin from 'react-google-login';
// import BlockUi from 'react-block-ui';
// import 'react-block-ui/style.css';

import {
    useLocation,
    useNavigate
} from "react-router-dom";

import { Header } from '../../components/Header'
import { Footer } from '../../components/Footer'

export const SignIn = () => {
    const history = useNavigate();
    const location = useLocation();

    const {
        values,
        errors,
        handleChange,
        handleSubmit,
    } = useForm(signIn, validate);

    const [success, setSuccess] = useState(false);
    const [hasErrors, setHasErrors] = useState(false);
    const [errorMessages, setErrorMessages] = useState('');
    const [state, setState] = useState(false);

    function showDefaultError() {
        setErrorMessages('Ha ocurrido un error inesperado, por favor vuelva a intentarlo más tarde.')
        setHasErrors(true);
    }

    function signIn() {
        setState(true);
        setHasErrors(false)
        setErrorMessages('')

        fetch(process.env.REACT_APP_API_URL + "/auth/login", {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(
                {
                    email: values.email,
                    password: values.password
                })
        })
            .then((response) => {
                if (response.ok) {
                    response.json().then(data => {
                        sessionStorage.setItem('kwt', data.token.auth_token);
                        setHasErrors(false);
                        setState(false);
                        window.location = "/profile";
                    });
                }
                else {
                    if (response.status === 500) {
                        showDefaultError();
                    }
                    else {
                        response.json().then(data => {
                            data.errors.forEach((error) => {
                                if (error === 'UserNotConfirmedEmail') {
                                    setErrorMessages('Tu usuario aún no está activado. Te hemos enviado un email para que puedas activarlo. En caso de que no encuentres el email en tu bandeja de entrada, por favor revisa en la carpeta de spam. ')
                                    setHasErrors(true);
                                }
                                else if (error === 'UserNotFound') {
                                    setErrorMessages('El usuario o contraseña no son correctos.')
                                    setHasErrors(true);
                                }
                                else {
                                    showDefaultError();
                                }
                            })
                        });
                    }
                    setState(false);
                }
            })
            .catch(function (error) {
                showDefaultError();
                setState(false);
            });
    }

    const responseFacebook = (response) => {
        console.log('facebook', response)
        setState(true);
        setHasErrors(false)
        setErrorMessages('')

        fetch(process.env.REACT_APP_API_URL + "/Auth/facebook", {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(
                {
                    token: response.accessToken
                })
        })
            .then((response) => {
                if (response.ok) {
                    response.json().then(data => {

                        sessionStorage.setItem('kwt', data.token.auth_token);
                        setHasErrors(false);
                        setState(false);
                        window.location = "/profile";
                    });
                }
                else {
                    if (response.status === 500) {
                        showDefaultError();
                    }
                    else {
                        response.json().then(data => {
                            data.errors.forEach((error) => {
                                if (error === 'UserNotFound') {
                                    setErrorMessages('El email ingresado no existe.')
                                    setHasErrors(true);
                                }
                            })
                        });
                    }

                    setSuccess(false);
                    setState(false);
                }
            })
            .catch(function (error) {
                showDefaultError();
                setState(false);
            });
    }

    const responseGoogleError = (response) => {
        showDefaultError();
    }

    const responseGoogle = (response) => {
        fetch(process.env.REACT_APP_API_URL + "/Auth/google", {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ token: response.tokenId })
        })
            .then((response) => {
                if (response.ok) {
                    response.json().then(data => {

                        sessionStorage.setItem('kwt', data.token.auth_token);
                        setHasErrors(false);
                        window.location = "/profile";
                    });
                }
                else {
                    if (response.status === 500) {
                        showDefaultError();
                    }
                    else {
                        response.json().then(data => {
                            data.errors.forEach((error) => {
                                if (error === 'UserNotFound') {
                                    setErrorMessages('El email ingresado no existe.')
                                    setHasErrors(true);
                                }
                            })
                        });
                    }

                    setSuccess(false);
                }
            })
            .catch(function (error) {
                showDefaultError();
            });
    }

    return (
        <>
            <Header />
            {/* <BlockUi tag="div" blocking={state}> </BlockUi>*/}
            <div id="sign-in-dialog" className="zoom-anim-dialog">
                <div className="small-dialog-header">
                    <h3>Iniciar sesión</h3>
                </div>
                <br />
                {hasErrors &&
                    <div className="notification error closeable">
                        <p>{errorMessages}</p>
                    </div>
                }
                <div className="sign-in-form style-1">
                    <form onSubmit={handleSubmit} method="post" className="login">
                        <p className="form-row form-row-wide">
                            <label for="email">Email:
                                <i className="im im-icon-Mail"></i>
                                <input type="text" className="input-text" name="email" id="email" onChange={handleChange} value={values.email || ''} />
                            </label>
                            {errors.email && (
                                <p className="help is-danger">{errors.email}</p>
                            )}
                        </p>
                        <p className="form-row form-row-wide">
                            <label for="password">Contraseña:
                                <i className="im im-icon-Lock-2"></i>
                                <input className="input-text" type="password" name="password" id="password" onChange={handleChange} value={values.password || ''} />
                            </label>
                            {errors.password && (
                                <p className="help is-danger">{errors.password}</p>
                            )}
                            <span>
                                <a className="lost_password" href="/recoveryPassword" >¿Has olvidado tu contraseña?</a>
                            </span>
                            <br />
                            <br />
                            <span className="spanColor">
                                Al hacer clic en <strong>"Iniciar sesión"</strong>, declaro que acepto los <a className="lost_password" target="_blank" href="/terms" >Términos de Uso</a> y que he leído la <a className="lost_password" target="_blank" href="/privacyPolicy" >Política de Privacidad.</a>
                            </span>
                        </p>
                        <div className="form-row">
                            <input type="submit" className="button border margin-top-5" name="login" value="Iniciar sesión" />
                        </div>
                    </form>
                    {/* <div className="socialButtonsDivs">
                        <FacebookLogin appId="507242187342828"
                            cssClass="button fbButton"
                            fields="name,email"
                            callback={responseFacebook} icon="fa-facebook" textButton=" Login con Facebook" />
                        <GoogleLogin clientId="511247574355-foqibqitofh7g093q97irr7ivj41qjpq.apps.googleusercontent.com"
                            className="button googleButton"
                            buttonText=" Login con Google"
                            onSuccess={responseGoogle}
                            onFailure={responseGoogleError}
                            cookiePolicy={'single_host_origin'}

                        />
                    </div> */}
                </div>
            </div>

            <Footer />
        </>
    )
}